<template>
  <DialogFactory :value="value" v-on="$listeners">
    <AbstractModalHeader title="Samochód">
      <template #append-item>
        <RemoveIconButton @click="openConfirmModal"></RemoveIconButton>
      </template>
      <template #close>
        <CloseIconButton @click="emitCloseEvent"></CloseIconButton>
      </template>
    </AbstractModalHeader>

    <ConfirmDialog
      :showDialog="isConfirmModalOpen"
      text="Czy chcesz usunąć samochód?"
      @confirm="onConfirm"
    ></ConfirmDialog>

    <v-card-text>
      <v-tabs v-model="selectedTab" grow>
        <v-tab>Szczegóły</v-tab>
      </v-tabs>

      <v-tabs-items class="mt-6" v-model="selectedTab">
        <v-tab-item>
          <DescriptionSection>
            <DescriptionItem title="Numer rejestracyjny" :value="carEntity && carEntity.registrationNumber" />
            <DescriptionItem title="Marka" :value="carEntity && carEntity.brand" />
            <DescriptionItem title="Model" :value="carEntity && carEntity.model" />
            <DescriptionItem title="Numer VIN" :value="carEntity && carEntity.vin" />
            <DescriptionItem title="Kierowca" :value="carEntity && carEntity.driverName" />
            <DescriptionItem title="Stan licznika" :value="carEntity && carEntity.initialMileage | mileageFormatter" />
            <DescriptionItem
              title="Pojemność silnika"
              :value="carEntity && carEntity.engineCapacity | engineCapacityFormatter"
            />
            <DescriptionItem
              title="Dodane przez"
              :value="carEntity && carEntity.createdAt | createdBy(carEntity.createdBy)"
            />
          </DescriptionSection>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </DialogFactory>
</template>

<script>
import DialogFactory from '@/component/Dialog/dialog-factory';
import AbstractModalHeader from '@/component/Dialog/abstract-modal-header';
import CloseIconButton from '@/component/Button/close-icon-button';
import RemoveIconButton from '@/component/Button/remove-icon-button';
import DescriptionSection from '@/component/Description/description-section';
import DescriptionItem from '@/component/Description/description-item';
import ConfirmDialog from '@/component/Dialog/confirm-dialog';

export default {
  name: 'CarPreviewModal',
  components: {
    DialogFactory,
    AbstractModalHeader,
    CloseIconButton,
    RemoveIconButton,
    DescriptionSection,
    DescriptionItem,
    ConfirmDialog,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    carEntity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedTab: 0,
      isConfirmModalOpen: false,
    };
  },
  methods: {
    emitCloseEvent() {
      this.$emit('close');
    },
    openConfirmModal() {
      this.isConfirmModalOpen = true;
    },
    onConfirm(confirmation) {
      if (confirmation) {
        this.$store.dispatch('car/deleteCar', this.carEntity).then(() => {
          this.$emit('carCreated', null);
          this.emitCloseEvent();
        });
      }
      this.isConfirmModalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
